import {
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import _ from 'lodash';
import React, {useState} from 'react';
import {MdChevronLeft} from 'react-icons/md';
import {useDispatch} from 'react-redux';
import BackToTopButton from '../../components/BackToTopButton';
import {useInAppTooltip} from '../../hooks/useInAppTooltip';
import PhotoGallery from './PhotoGallery';
import MapNavButton from './MapNavButton';

const PinPhotosModal = ({onClose, photoUrls, pin}) => {
  const dispatch = useDispatch();


  const [scrollableRef, setScrollableRef] = useState(null);
  const backButtonTooltipProps = useInAppTooltip('Back to Places');

  return (
    <Modal
      // blockScrollOnMount={false}
      isOpen
      onClose={() => {
        if (onClose) onClose();
      }}
      size="full"
      scrollBehavior="inside"
      // finalFocusRef={} // The ref of element to receive focus when the modal closes.
    >
      <ModalOverlay/>

      <ModalContent
        bg="bg"
      >
        <ModalHeader
          display="flex"
          flexDirection="column"
          p={0}
        >
          <Flex justifyContent="space-between" p={4} gap={4}>
            <ModalCloseButton
              bg="white"
              borderRadius="xl"
              fontSize="1em"
              height="40px"
              position="relative"
              right="unset"
              top="unset"
              width="3.5em"

              {...{
                ...backButtonTooltipProps,

                color: 'black24',

                _hover: {
                  filter: `brightness(0.8)`,
                  shadow: 'none',

                  _disabled: {
                    bg: 'inactiveGrey',
                  }
                },
                _focus: {
                  shadow: 'none',
                },
                _focusVisible: {
                  shadow: 'none',
                },
              }}
            >
              <MdChevronLeft/>
              <Text fontSize="0.75em">Back</Text>
            </ModalCloseButton>

            <Text
              align="center"
              fontSize={'2xl'}
            >
              {pin.label}
            </Text>

            <MapNavButton
              latitude={_.get(pin, 'location.Latitude')}
              longitude={_.get(pin, 'location.Longitude')}
            />

          </Flex>


        </ModalHeader>


        <ModalBody
          bg="bg"
          p={0}
          ref={el => {
            setScrollableRef(el);
          }}
          sx={{
            '&::-webkit-scrollbar': {
              width: '8px',
              borderRadius: '8px',
              backgroundColor: `rgba(0, 0, 0, 0.07)`,
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: `rgba(0, 0, 0, 0.07)`,
            },
          }}
        >
          {!_.isEmpty(photoUrls) && (
            <PhotoGallery photoDimensions={pin.photos.map(p => p.dimensions)} photoUrls={photoUrls}/>
          )}
        </ModalBody>

        {/*<DrawerFooter>*/}
        {/*</DrawerFooter>*/}

        {scrollableRef && <BackToTopButton element={scrollableRef}/>}

      </ModalContent>
    </Modal>
  );


};

export default PinPhotosModal;
